import _objectSpread from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { createTheme, Dialog, DialogContent, DialogTitle, ThemeProvider, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ConnectorUiForm from "./connector-ui-form";
import { defaultCreateHandler, defaultReadHandler } from "./handler.js";

/**
	// required
* @param {string} GRAPHISTRY_HOST - API server url, default is "http://nexus"
* @param {Function} handleOpen - change the open state value
* @param {Function} onTest - function to run when test button is click
* @param {useState} open - state of dialog, is dialog open or close
* @param {object} styles - styling property here
* @param {useState} testMessage - test message result
* @param {object} user - 

	// optional
* @param {Array} falcorConnectors - give the component connector value, without calling readHandler
* @param {useState} pk - connector id
* @param {Function} setTestMessage - change the value of testMessage

	// handler
* @param {Function} createHandler - 
* @param {Function} readHandler -
* @param {Function} updateHandler -

 * @returns - return a mui/Dialog component
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ConnectorUIDialog = function ConnectorUIDialog(_ref) {
  var GRAPHISTRY_HOST = _ref.GRAPHISTRY_HOST,
    handleOpen = _ref.handleOpen,
    _onTest = _ref.onTest,
    open = _ref.open,
    styles = _ref.styles,
    testMessage = _ref.testMessage,
    user = _ref.user,
    _ref$falcorConnectors = _ref.falcorConnectors,
    falcorConnectors = _ref$falcorConnectors === void 0 ? [] : _ref$falcorConnectors,
    _ref$pk = _ref.pk,
    pk = _ref$pk === void 0 ? "" : _ref$pk,
    _ref$setTestMessage = _ref.setTestMessage,
    setTestMessage = _ref$setTestMessage === void 0 ? function () {} : _ref$setTestMessage,
    createHandler = _ref.createHandler,
    readHandler = _ref.readHandler,
    updateHandler = _ref.updateHandler;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeStep = _useState2[0],
    _setActiveStep = _useState2[1];
  var _useState3 = useState(falcorConnectors),
    _useState4 = _slicedToArray(_useState3, 2),
    connectors = _useState4[0],
    setConnectors = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFalcor = _useState6[0],
    setIsFalcor = _useState6[1];
  var _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    keyJson = _useState8[0],
    _setKeyJson = _useState8[1];
  var _useState9 = useState(""),
    _useState10 = _slicedToArray(_useState9, 2),
    name = _useState10[0],
    _setName = _useState10[1];
  var _useState11 = useState(""),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedValue = _useState12[0],
    setSelectedValue = _useState12[1];
  var theme = createTheme({
    typography: styles["typography"]
  });
  var handleClose = function handleClose() {
    handleOpen(false);
    _setActiveStep(0);
    setSelectedValue("");
    _setKeyJson({});
    setTestMessage("Health checks have never been run.");
  };
  var handleSave = function handleSave() {
    var convertedKeyJson = "other" in keyJson ? _objectSpread(_objectSpread({}, keyJson), {}, {
      other: checkAndConvert(keyJson.other)
    }) : "schema" in keyJson ? _objectSpread(_objectSpread({}, keyJson), {}, {
      schema: _objectSpread(_objectSpread({}, keyJson.schema), {}, {
        labelProperties: checkAndConvert(keyJson.schema.labelProperties),
        relationshipProperties: checkAndConvert(keyJson.schema.relationshipProperties)
      })
    }) : keyJson;
    if (createHandler === undefined) createHandler = defaultCreateHandler;
    if (pk !== "") {
      var connectorKeyJson = connectors.filter(function (connector) {
        return connector.id === pk;
      })[0].keyjson;
      if ((convertedKeyJson === null || convertedKeyJson === void 0 ? void 0 : convertedKeyJson.key) === "" && (connectorKeyJson === null || connectorKeyJson === void 0 ? void 0 : connectorKeyJson.key) !== undefined) {
        convertedKeyJson["key"] = connectorKeyJson.key;
      }
      if ((convertedKeyJson === null || convertedKeyJson === void 0 ? void 0 : convertedKeyJson.password) === "" && (connectorKeyJson === null || connectorKeyJson === void 0 ? void 0 : connectorKeyJson.password) !== undefined) {
        convertedKeyJson["password"] = connectorKeyJson.password;
      }
      console.log("connectorKeyJson: ", connectorKeyJson);
      console.log("convertedKeyJson: ", convertedKeyJson);
      updateHandler(user, pk, selectedValue, name, convertedKeyJson, GRAPHISTRY_HOST);
    } else {
      createHandler(user, selectedValue, name, convertedKeyJson, GRAPHISTRY_HOST);
    }
    handleClose();
  };
  var handleNameChange = function handleNameChange(event) {
    var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value;
    var length = Object.keys(falcorConnectors).map(function (connector) {
      return falcorConnectors[connector];
    }).filter(function (connector) {
      return connector.type === value.split(" ")[0];
    }).length;
    var numbering = length ? " ".concat(length) : "";
    var connectorName = "".concat(value).concat(numbering);
    if (name === "type") {
      setSelectedValue(value);
      _setName(connectorName);
    }
    if (name === "name") {
      _setName(value);
    }
  };
  function checkAndConvert(value) {
    return typeof value === "string" || value instanceof String ? tryConvert(value) : value;
  }
  function tryConvert(input) {
    try {
      return JSON.parse(input);
    } catch (error) {
      return input;
    }
  }
  useEffect(function () {
    if (Array.isArray(falcorConnectors) && falcorConnectors.length === 0) {
      if (readHandler === undefined) readHandler = defaultReadHandler;
      readHandler(function (connector) {
        return setConnectors(connector);
      }, user.jwtToken, GRAPHISTRY_HOST);
    } else {
      setConnectors(falcorConnectors);
      setIsFalcor(true);
    }
  }, []);
  useEffect(function () {
    if (pk !== "") {
      if (readHandler === undefined) readHandler = defaultReadHandler;
      readHandler(function (connector) {
        return setConnectors(connector);
      }, user.jwtToken, GRAPHISTRY_HOST);
      handleOpen(true);
    } else if (pk === "") {
      _setActiveStep(0);
      setTestMessage("Health checks have never been run.");
      _setKeyJson({});
      _setName("");
      setSelectedValue("");
    }
  }, [pk]);
  useEffect(function () {
    var connector = connectors.filter(function (connector) {
      return connector.id === pk;
    })[0];
    if (connector) {
      _setActiveStep(1);
      if (connector !== null && connector !== void 0 && connector.keyjson) {
        _setKeyJson(_objectSpread(_objectSpread({}, connector.keyjson), {}, {
          key: "",
          password: ""
        }));
      }
      _setName(connector.name);
      setSelectedValue(connector.type);
    }
  }, [connectors, open]);
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: theme,
    children: /*#__PURE__*/_jsxs(Dialog, {
      style: styles["parent-style"],
      open: open,
      onClose: handleClose,
      maxWidth: "md",
      children: [/*#__PURE__*/_jsx(DialogTitle, {
        children: /*#__PURE__*/_jsx(Typography, {
          variant: "inherit",
          children: "Connector Form"
        })
      }), /*#__PURE__*/_jsx(DialogContent, {
        style: {
          paddingRight: "25px",
          paddingLeft: "25px",
          paddingBottom: "25px",
          minWidth: "350px"
        },
        children: /*#__PURE__*/_jsx(ConnectorUiForm, {
          activeStep: activeStep,
          falcorConnectors: falcorConnectors,
          handleClose: handleClose,
          handleSave: handleSave,
          isFalcor: isFalcor,
          isSuperUserOrStaff: user.isStaff || user.isSuperUser,
          keyJson: keyJson,
          name: name,
          onTest: function onTest() {
            return _onTest(selectedValue, keyJson);
          },
          selectedValue: selectedValue,
          setActiveStep: function setActiveStep(activeStep) {
            return _setActiveStep(activeStep);
          },
          handleSelectedValue: function handleSelectedValue(selectedValue) {
            return setSelectedValue(selectedValue);
          },
          setKeyJson: function setKeyJson(keyJson) {
            return _setKeyJson(keyJson);
          },
          setName: function setName(name) {
            return _setName(name);
          },
          styles: styles,
          testMessage: testMessage
        })
      })]
    })
  });
};
export default ConnectorUIDialog;